import { ISidebarNavigationBase, ISidebarNavigationSubBase } from 'interfaces/navigation';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS, IForBankSections } from './businessToolSections/forBank';
import {
  FOR_INVESTORS_SECTIONS,
  FOR_INVESTORS_SUB_SECTIONS,
  IForInvestorsSections,
} from './businessToolSections/forInvestors';
import { ONE_PAGE_SECTIONS } from './businessToolSections/onePage';

export const ONE_PAGE_NAVIGATION_SEQUENCE: ISidebarNavigationBase[] = [
  {
    name: ONE_PAGE_SECTIONS.ABOUT_THE_COMPANY,
    nextItem: ONE_PAGE_SECTIONS.ABOUT_THE_PROJECT,
    prevItem: ONE_PAGE_SECTIONS.IMPLEMENTATION_PLAN,
  },
  {
    name: ONE_PAGE_SECTIONS.ABOUT_THE_PROJECT,
    nextItem: ONE_PAGE_SECTIONS.PRODUCTS_SERVICES,
    prevItem: ONE_PAGE_SECTIONS.ABOUT_THE_COMPANY,
  },
  {
    name: ONE_PAGE_SECTIONS.PRODUCTS_SERVICES,
    nextItem: ONE_PAGE_SECTIONS.MARKET_AND_SALES,
    prevItem: ONE_PAGE_SECTIONS.ABOUT_THE_PROJECT,
  },
  {
    name: ONE_PAGE_SECTIONS.MARKET_AND_SALES,
    nextItem: ONE_PAGE_SECTIONS.TEAM,
    prevItem: ONE_PAGE_SECTIONS.PRODUCTS_SERVICES,
  },
  {
    name: ONE_PAGE_SECTIONS.TEAM,
    nextItem: ONE_PAGE_SECTIONS.FINANCIAL_PROJECTIONS,
    prevItem: ONE_PAGE_SECTIONS.MARKET_AND_SALES,
  },
  {
    name: ONE_PAGE_SECTIONS.FINANCIAL_PROJECTIONS,
    nextItem: ONE_PAGE_SECTIONS.FINANCING_NEEDS,
    prevItem: ONE_PAGE_SECTIONS.TEAM,
  },
  {
    name: ONE_PAGE_SECTIONS.FINANCING_NEEDS,
    nextItem: ONE_PAGE_SECTIONS.IMPLEMENTATION_PLAN,
    prevItem: ONE_PAGE_SECTIONS.FINANCIAL_PROJECTIONS,
  },
  {
    name: ONE_PAGE_SECTIONS.IMPLEMENTATION_PLAN,
    nextItem: ONE_PAGE_SECTIONS.ABOUT_THE_COMPANY,
    prevItem: ONE_PAGE_SECTIONS.FINANCING_NEEDS,
  },
];

export const FOR_BANK_NAVIGATION_SEQUENCE: ISidebarNavigationBase[] = [
  {
    name: FOR_BANK_SECTIONS.OVERVIEW,
    nextItem: FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY,
    prevItem: FOR_BANK_SECTIONS.FINANCIAL_PLAN,
  },
  {
    name: FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY,
    nextItem: FOR_BANK_SECTIONS.ABOUT_COMPANY,
    prevItem: FOR_BANK_SECTIONS.OVERVIEW,
  },
  {
    name: FOR_BANK_SECTIONS.ABOUT_COMPANY,
    nextItem: FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES,
    prevItem: FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY,
  },
  {
    name: FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES,
    nextItem: FOR_BANK_SECTIONS.MARKET_ANALYSIS,
    prevItem: FOR_BANK_SECTIONS.ABOUT_COMPANY,
  },
  {
    name: FOR_BANK_SECTIONS.MARKET_ANALYSIS,
    nextItem: FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    prevItem: FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES,
  },
  {
    name: FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    nextItem: FOR_BANK_SECTIONS.BUSINESS_OPERATIONS,
    prevItem: FOR_BANK_SECTIONS.MARKET_ANALYSIS,
  },
  {
    name: FOR_BANK_SECTIONS.BUSINESS_OPERATIONS,
    nextItem: FOR_BANK_SECTIONS.MANAGEMENT_AND_ORGANIZATION,
    prevItem: FOR_BANK_SECTIONS.MARKETING_AND_SALES,
  },
  {
    name: FOR_BANK_SECTIONS.MANAGEMENT_AND_ORGANIZATION,
    nextItem: FOR_BANK_SECTIONS.IMPLEMENTATION_PLAN,
    prevItem: FOR_BANK_SECTIONS.BUSINESS_OPERATIONS,
  },
  {
    name: FOR_BANK_SECTIONS.IMPLEMENTATION_PLAN,
    nextItem: FOR_BANK_SECTIONS.FINANCIAL_PLAN,
    prevItem: FOR_BANK_SECTIONS.MANAGEMENT_AND_ORGANIZATION,
  },
  {
    name: FOR_BANK_SECTIONS.FINANCIAL_PLAN,
    nextItem: FOR_BANK_SECTIONS.OVERVIEW,
    prevItem: FOR_BANK_SECTIONS.IMPLEMENTATION_PLAN,
  },
];

export const FOR_INVESTORS_NAVIGATION_SEQUENCE: ISidebarNavigationBase[] = [
  {
    name: FOR_INVESTORS_SECTIONS.OVERVIEW,
    nextItem: FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY,
    prevItem: FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN,
  },
  {
    name: FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY,
    nextItem: FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT,
    prevItem: FOR_INVESTORS_SECTIONS.OVERVIEW,
  },
  {
    name: FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT,
    nextItem: FOR_INVESTORS_SECTIONS.MARKET_ANALYSIS,
    prevItem: FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY,
  },
  {
    name: FOR_INVESTORS_SECTIONS.MARKET_ANALYSIS,
    nextItem: FOR_INVESTORS_SECTIONS.MARKETING_AND_SALES,
    prevItem: FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT,
  },
  {
    name: FOR_INVESTORS_SECTIONS.MARKETING_AND_SALES,
    nextItem: FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS,
    prevItem: FOR_INVESTORS_SECTIONS.MARKET_ANALYSIS,
  },
  {
    name: FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS,
    nextItem: FOR_INVESTORS_SECTIONS.MANAGEMENT_AND_ORGANIZATION,
    prevItem: FOR_INVESTORS_SECTIONS.MARKETING_AND_SALES,
  },
  {
    name: FOR_INVESTORS_SECTIONS.MANAGEMENT_AND_ORGANIZATION,
    nextItem: FOR_INVESTORS_SECTIONS.RAISING_AND_ALLOCATING_FUNDS,
    prevItem: FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS,
  },
  {
    name: FOR_INVESTORS_SECTIONS.RAISING_AND_ALLOCATING_FUNDS,
    nextItem: FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN,
    prevItem: FOR_INVESTORS_SECTIONS.MANAGEMENT_AND_ORGANIZATION,
  },
  {
    name: FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN,
    nextItem: FOR_INVESTORS_SECTIONS.OVERVIEW,
    prevItem: FOR_INVESTORS_SECTIONS.RAISING_AND_ALLOCATING_FUNDS,
  },
];

export const FOR_INVESTORS_NAVIGATION_SUB_SEQUENCE: Record<IForInvestorsSections, ISidebarNavigationSubBase[]> = {
  [FOR_INVESTORS_SECTIONS.OVERVIEW]: [
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.OVERVIEW].COMPANY,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.OVERVIEW].PROJECT,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.OVERVIEW].PROJECT,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.OVERVIEW].MARKET_CUSTOMERS,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.OVERVIEW].COMPANY,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.OVERVIEW].MARKET_CUSTOMERS,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.OVERVIEW].FINANCIAL_INFO,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.OVERVIEW].PROJECT,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.OVERVIEW].FINANCIAL_INFO,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.OVERVIEW].FUNDING_NEEDS,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.OVERVIEW].COMPANY,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.OVERVIEW].FUNDING_NEEDS,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.OVERVIEW].FINANCIAL_INFO,
    },
  ],
  [FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY]: [
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY].GOALS_AND_OBJECTIVES,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY].COMPANY_DESCRIPTION,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY].COMPANY_DESCRIPTION,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY].PRODUCTS_OR_SERVICES,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY].GOALS_AND_OBJECTIVES,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY].PRODUCTS_OR_SERVICES,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY].MARKET_AND_CUSTOMERS,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY].COMPANY_DESCRIPTION,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY].MARKET_AND_CUSTOMERS,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY].ORGANIZATION_AND_TEAM,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY].PRODUCTS_OR_SERVICES,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY].ORGANIZATION_AND_TEAM,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY].FINANCIAL_INFORMATION,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY].MARKET_AND_CUSTOMERS,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY].FINANCIAL_INFORMATION,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY].FINANCING_NEEDS,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY].ORGANIZATION_AND_TEAM,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY].FINANCING_NEEDS,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY].FINANCIAL_INFORMATION,
    },
  ],
  [FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT]: [
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT].GENERAL_INFO,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT].COMPANY_HISTORY,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT].COMPANY_HISTORY,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT].ABOUT_THE_PROJECT,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT].GENERAL_INFO,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT].ABOUT_THE_PROJECT,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT].IMPLEMENTATION_PLAN,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT].COMPANY_HISTORY,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT].IMPLEMENTATION_PLAN,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT].SWOT,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT].ABOUT_THE_PROJECT,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT].SWOT,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT].IMPLEMENTATION_PLAN,
    },
  ],
  [FOR_INVESTORS_SECTIONS.MARKET_ANALYSIS]: [
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.MARKET_ANALYSIS].MARKET_OVERVIEW,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.MARKET_ANALYSIS].COMPETITIVE_ANALYSIS,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.MARKET_ANALYSIS].COMPETITIVE_ANALYSIS,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.MARKET_ANALYSIS].CONSUMER_NEEDS,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.MARKET_ANALYSIS].MARKET_OVERVIEW,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.MARKET_ANALYSIS].CONSUMER_NEEDS,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.MARKET_ANALYSIS].COMPETITIVE_ANALYSIS,
    },
  ],
  [FOR_INVESTORS_SECTIONS.MARKETING_AND_SALES]: [
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.MARKETING_AND_SALES].SALES_PLAN,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.MARKETING_AND_SALES].MARKETING_PLAN,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.MARKETING_AND_SALES].MARKETING_PLAN,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.MARKETING_AND_SALES].SALES_PLAN,
    },
  ],
  [FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS]: [
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS].LOCATION_AND_PREMISES,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS].EQUIPMENT,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS].EQUIPMENT,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS].ASSETS,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS].LOCATION_AND_PREMISES,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS].ASSETS,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS].TECHNOLOGICAL_PROCESS,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS].EQUIPMENT,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS].TECHNOLOGICAL_PROCESS,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS].PRODUCTION,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS].ASSETS,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS].PRODUCTION,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS].PRODUCT_DESCRIPTION,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS].TECHNOLOGICAL_PROCESS,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS].PRODUCT_DESCRIPTION,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS].UNIQUENESS,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS].PRODUCTION,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS].UNIQUENESS,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS].PRODUCT_DESCRIPTION,
    },
  ],
  [FOR_INVESTORS_SECTIONS.MANAGEMENT_AND_ORGANIZATION]: [
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.MANAGEMENT_AND_ORGANIZATION].MANAGEMENT_TEAM,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.MANAGEMENT_AND_ORGANIZATION].STAFF_ORGANIZATION,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.MANAGEMENT_AND_ORGANIZATION].STAFF_ORGANIZATION,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.MANAGEMENT_AND_ORGANIZATION].MANAGEMENT_TEAM,
    },
  ],
  [FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN]: [
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN].KEY_ASSUMPTIONS,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN].REVENUE_PLAN,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN].REVENUE_PLAN,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN].PLANNED_EXPENSES,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN].KEY_ASSUMPTIONS,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN].PLANNED_EXPENSES,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN].PROFIT_AND_LOSS,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN].REVENUE_PLAN,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN].PROFIT_AND_LOSS,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN].CASH_FLOW_ELEMENTS,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN].PLANNED_EXPENSES,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN].CASH_FLOW_ELEMENTS,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN].PROJECTED_CASH_FLOW,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN].PROFIT_AND_LOSS,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN].PROJECTED_CASH_FLOW,
      nextItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN].FINANCIAL_PERFORMANCE,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN].CASH_FLOW_ELEMENTS,
    },
    {
      name: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN].FINANCIAL_PERFORMANCE,
      prevItem: FOR_INVESTORS_SUB_SECTIONS[FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN].PROJECTED_CASH_FLOW,
    },
  ],
} as Record<IForInvestorsSections, ISidebarNavigationSubBase[]>;

export const FOR_BANK_NAVIGATION_SUB_SEQUENCE: Record<IForBankSections, ISidebarNavigationSubBase[]> = {
  [FOR_BANK_SECTIONS.OVERVIEW]: [
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.OVERVIEW].COMPANY,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.OVERVIEW].PROJECT,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.OVERVIEW].PROJECT,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.OVERVIEW].MARKET_CUSTOMERS,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.OVERVIEW].COMPANY,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.OVERVIEW].MARKET_CUSTOMERS,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.OVERVIEW].FINANCIAL_INFO,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.OVERVIEW].PROJECT,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.OVERVIEW].FINANCIAL_INFO,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.OVERVIEW].FUNDING_NEEDS,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.OVERVIEW].COMPANY,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.OVERVIEW].FUNDING_NEEDS,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.OVERVIEW].FINANCIAL_INFO,
    },
  ],
  [FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY]: [
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].GOALS_AND_OBJECTIVES,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].COMPANY_DESCRIPTION,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].COMPANY_DESCRIPTION,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].PRODUCTS_OR_SERVICES,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].GOALS_AND_OBJECTIVES,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].PRODUCTS_OR_SERVICES,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].MARKET_AND_CUSTOMERS,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].COMPANY_DESCRIPTION,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].MARKET_AND_CUSTOMERS,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].ORGANIZATION_AND_TEAM,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].PRODUCTS_OR_SERVICES,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].ORGANIZATION_AND_TEAM,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].FINANCIAL_INFORMATION,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].MARKET_AND_CUSTOMERS,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].FINANCIAL_INFORMATION,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].FINANCING_NEEDS,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].ORGANIZATION_AND_TEAM,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].FINANCING_NEEDS,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].RISKS,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].FINANCIAL_INFORMATION,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].RISKS,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY].FINANCING_NEEDS,
    },
  ],
  [FOR_BANK_SECTIONS.ABOUT_COMPANY]: [
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.ABOUT_COMPANY].GENERAL_INFO,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.ABOUT_COMPANY].COMPANY_HISTORY,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.ABOUT_COMPANY].COMPANY_HISTORY,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.ABOUT_COMPANY].MISSION_AND_STRATEGY,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.ABOUT_COMPANY].GENERAL_INFO,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.ABOUT_COMPANY].MISSION_AND_STRATEGY,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.ABOUT_COMPANY].SWOT,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.ABOUT_COMPANY].COMPANY_HISTORY,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.ABOUT_COMPANY].SWOT,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.ABOUT_COMPANY].MISSION_AND_STRATEGY,
    },
  ],
  [FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES]: [
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES].DESCRIPTION,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES].ADVANTAGES,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES].ADVANTAGES,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES].R_AND_D,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES].DESCRIPTION,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES].R_AND_D,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES].DELIVERY_AND_SUPPORT,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES].ADVANTAGES,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES].DELIVERY_AND_SUPPORT,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES].R_AND_D,
    },
  ],
  [FOR_BANK_SECTIONS.MARKET_ANALYSIS]: [
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.MARKET_ANALYSIS].MARKET_OVERVIEW,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.MARKET_ANALYSIS].COMPETITIVE_ANALYSIS,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.MARKET_ANALYSIS].COMPETITIVE_ANALYSIS,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.MARKET_ANALYSIS].CONSUMER_NEEDS,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.MARKET_ANALYSIS].MARKET_OVERVIEW,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.MARKET_ANALYSIS].CONSUMER_NEEDS,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.MARKET_ANALYSIS].COMPETITIVE_ANALYSIS,
    },
  ],
  [FOR_BANK_SECTIONS.MARKETING_AND_SALES]: [
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.MARKETING_AND_SALES].SALES_PLAN,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.MARKETING_AND_SALES].MARKETING_PLAN,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.MARKETING_AND_SALES].MARKETING_PLAN,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.MARKETING_AND_SALES].SALES_PLAN,
    },
  ],
  [FOR_BANK_SECTIONS.BUSINESS_OPERATIONS]: [
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].LOCATION_AND_PREMISES,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].EQUIPMENT,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].EQUIPMENT,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].ASSETS,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].LOCATION_AND_PREMISES,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].ASSETS,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].TECHNOLOGICAL_PROCESS,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].EQUIPMENT,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].TECHNOLOGICAL_PROCESS,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].WORKING_RESOURCES,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].ASSETS,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].WORKING_RESOURCES,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].PARTNERS,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].TECHNOLOGICAL_PROCESS,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].PARTNERS,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].PRODUCTION,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].WORKING_RESOURCES,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].PRODUCTION,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].QUALITY,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].PARTNERS,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].QUALITY,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.BUSINESS_OPERATIONS].PRODUCTION,
    },
  ],
  [FOR_BANK_SECTIONS.MANAGEMENT_AND_ORGANIZATION]: [
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.MANAGEMENT_AND_ORGANIZATION].MANAGEMENT_TEAM,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.MANAGEMENT_AND_ORGANIZATION].EXTERNAL_PARTNERS_AND_ADVISERS,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.MANAGEMENT_AND_ORGANIZATION].EXTERNAL_PARTNERS_AND_ADVISERS,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.MANAGEMENT_AND_ORGANIZATION].STAFF_ORGANIZATION,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.MANAGEMENT_AND_ORGANIZATION].MANAGEMENT_TEAM,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.MANAGEMENT_AND_ORGANIZATION].STAFF_ORGANIZATION,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.MANAGEMENT_AND_ORGANIZATION].EXTERNAL_PARTNERS_AND_ADVISERS,
    },
  ],
  [FOR_BANK_SECTIONS.FINANCIAL_PLAN]: [
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].KEY_ASSUMPTIONS,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].REVENUE_PLAN,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].REVENUE_PLAN,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].PLANNED_EXPENSES,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].KEY_ASSUMPTIONS,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].PLANNED_EXPENSES,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].PROFIT_AND_LOSS_PROJECTION,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].REVENUE_PLAN,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].PROFIT_AND_LOSS_PROJECTION,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].CASH_FLOW_ELEMENTS,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].PLANNED_EXPENSES,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].CASH_FLOW_ELEMENTS,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].PROJECTED_CASH_FLOW,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].PROFIT_AND_LOSS_PROJECTION,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].PROJECTED_CASH_FLOW,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].OPENING_BALANCE_SHEETS,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].CASH_FLOW_ELEMENTS,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].OPENING_BALANCE_SHEETS,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].PROJECTED_BALANCE_SHEETS,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].PROJECTED_CASH_FLOW,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].PROJECTED_BALANCE_SHEETS,
      nextItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].FINANCIAL_PERFORMANCE,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].OPENING_BALANCE_SHEETS,
    },
    {
      name: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].FINANCIAL_PERFORMANCE,
      prevItem: FOR_BANK_SUB_SECTIONS[FOR_BANK_SECTIONS.FINANCIAL_PLAN].PROJECTED_BALANCE_SHEETS,
    },
  ],
} as Record<IForBankSections, ISidebarNavigationSubBase[]>;
